import * as service from './service'
export default {
  namespace: 'commonSmartCaptcha',
  state: {
    formState: {
      captchaInfo: {
        value: ''
      }
    }
  },
  effects: {

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    },
    save_fields (state, { payload }) {
      return {
        ...state,
        formState: {
          ...state.formState,
          ...payload
        }
      }
    }
  }
}
